<cui-data-list class="table" density="condensed">
  @if (isBusiness) {
  <cui-data-list-row label="Company">
    {{ businessName | titlecase | claValueOrNA }}
  </cui-data-list-row>
  } @else {
  <cui-data-list-row label="First">
    {{ firstName | titlecase | claValueOrNA }}
  </cui-data-list-row>
  <cui-data-list-row>
    <span list-item-label>
      <span class="screen-reader-only">Middle</span>
      <span aria-hidden="true">Middle</span>
    </span>
    {{ middleInitial | titlecase | claValueOrNA }}
  </cui-data-list-row>
  <cui-data-list-row label="Last">
    {{ lastName | titlecase | claValueOrNA }}
  </cui-data-list-row>
  <cui-data-list-row label="Suffix">
    {{ suffix | titlecase | claValueOrNA }}
  </cui-data-list-row>
  }
  <cui-data-list-row label="DBA">
    {{ dbaName | titlecase | claValueOrNA }}
  </cui-data-list-row>
  <cui-data-list-row label="Address">
    <span [innerHTML]="streetName | claValueOrNA"></span>
    @if (secondStreetName !== '') {
    <span [innerHtml]="secondStreetName"></span>
    } @if (cityStateZip !== '') {
    <span [innerHTML]="cityStateZip"></span>
    }
  </cui-data-list-row>
  @if (formattedPhoneNumbers?.length === 0) {
  <cui-data-list-row label="Phone">-</cui-data-list-row>
  } @if (formattedPhoneNumbers?.length === 1) {
  <cui-data-list-row label="Phone">
    {{ formattedPhoneNumbers[0] }}
  </cui-data-list-row>
  } @if (formattedPhoneNumbers?.length > 1) { @for (phoneNumber of
  formattedPhoneNumbers; track phoneNumber) {
  <span></span>
  <cui-data-list-row label="Phone {{ findIndex(phoneNumber) }}">
    {{ phoneNumber }}
  </cui-data-list-row>
  } } @if (formattedEmails?.length === 0) {
  <cui-data-list-row label="Email">-</cui-data-list-row>
  } @if (formattedEmails?.length === 1) {
  <cui-data-list-row label="Email">
    {{ formattedEmails[0] }}
  </cui-data-list-row>
  } @if (formattedEmails?.length > 1) { @for (email of formattedEmails; track
  email) {
  <span></span>
  <cui-data-list-row label="Email {{ findEmailIndex(email) }}">
    {{ email }}
  </cui-data-list-row>
  } }
</cui-data-list>
